import type { Location } from '@brightlocal/api-client';
import { formatAddress } from '@brightlocal/shared';

/**
 * The switcher's one-line address: street and postcode. `formatAddress` only joins its two
 * arguments with a comma, so the street goes where it expects a city.
 */
export const formatLocationStreetAddress = ({
  address1,
  postcode
}: Pick<Location['address'], 'address1' | 'postcode'>) => formatAddress(address1, postcode);
